import { createContext } from 'react';
import type { SelectedFilterItemsContextType } from '../types/SelectedFilterItemsContextType';

export const SelectedNodesContext = createContext<
  SelectedFilterItemsContextType | undefined
>(undefined);
